import { CapacitorDataStorageSqlite } from 'capacitor-data-storage-sqlite';

export default class StorageService {

  static instance;
  initialised = false;

  static getInstance() {
    if (!StorageService.instance) {
      StorageService.instance = new StorageService();
    }
    return StorageService.instance;
  }

  async init() {
    if (this.initialised) { return; }

    await CapacitorDataStorageSqlite.openStore({});

    this.initialised = true;
  }

  async set(obj) {
    await this.init();
    await CapacitorDataStorageSqlite.set(obj);
    return true;
  }

  async get(obj) {
    await this.init();
    const value = await CapacitorDataStorageSqlite.get(obj);
    return value ?? null;
  }

  async remove(obj) {
    await this.init();
    await CapacitorDataStorageSqlite.remove(obj);
    return true;
  }

  async clear() {
    await this.init();
    await CapacitorDataStorageSqlite.clear();
    return true;
  }

  async keys() {
    await this.init();
    const { keys } = await CapacitorDataStorageSqlite.keys();
    return keys;
  }
}

